import { ref } from 'vue'

import { defineStore } from 'pinia'

export const useNotificationPermissionStore = defineStore('notificationPermission', () => {
  const isNotificationPermission = ref(false)
  const isSystemNotificationApproved = ref(false)

  const updateNotificationPermission = value => {
    isNotificationPermission.value = value
  }

  const updateSystemNotificationApproval = value => {
    isSystemNotificationApproved.value = value
  }

  return {
    isNotificationPermission,
    isSystemNotificationApproved,
    updateNotificationPermission,
    updateSystemNotificationApproval
  }
})
